import {
  BookOpen, Coffee, Dumbbell, Bed, Users, Utensils, ShoppingBag,
  Music, Palette, Gamepad2, Brain, HeartHandshake, Stethoscope,
  Bath, Sparkles, Sun, Moon, Headphones, Star, Flag, Home, Book, Briefcase,
} from "lucide-react";

export const DAYS = [
  { key: "mon", label: "Monday" },
  { key: "tue", label: "Tuesday" },
  { key: "wed", label: "Wednesday" },
  { key: "thu", label: "Thursday" },
  { key: "fri", label: "Friday" },
  { key: "sat", label: "Saturday" },
  { key: "sun", label: "Sunday" },
];

// Warm, soft, high-contrast category palette
export const CATEGORIES = {
  routine:      { label: "Routine",     bg: "bg-amber-50",    border: "border-amber-300",   accent: "border-l-amber-500",  text: "text-amber-900" },
  school_work:  { label: "School / Work", bg: "bg-blue-50",   border: "border-blue-300",    accent: "border-l-blue-500",   text: "text-blue-900" },
  fun:          { label: "Fun",         bg: "bg-pink-50",     border: "border-pink-300",    accent: "border-l-pink-500",   text: "text-pink-900" },
  self_care:    { label: "Self care",   bg: "bg-purple-50",   border: "border-purple-300",  accent: "border-l-purple-500", text: "text-purple-900" },
  social:       { label: "Social",      bg: "bg-orange-50",   border: "border-orange-300",  accent: "border-l-orange-500", text: "text-orange-900" },
  quiet_time:   { label: "Quiet time",  bg: "bg-emerald-50",  border: "border-emerald-300", accent: "border-l-emerald-500",text: "text-emerald-900" },
  appointment:  { label: "Appointment", bg: "bg-rose-50",     border: "border-rose-300",    accent: "border-l-rose-500",   text: "text-rose-900" },
  exercise:     { label: "Exercise",    bg: "bg-teal-50",     border: "border-teal-300",    accent: "border-l-teal-500",   text: "text-teal-900" },
};

export const CATEGORY_KEYS = Object.keys(CATEGORIES);

export const ICONS = {
  star: Star, book: Book, coffee: Coffee, dumbbell: Dumbbell,
  bed: Bed, users: Users, food: Utensils, shopping: ShoppingBag,
  music: Music, art: Palette, game: Gamepad2, brain: Brain,
  care: HeartHandshake, doctor: Stethoscope, bath: Bath,
  spark: Sparkles, sun: Sun, moon: Moon, headphones: Headphones,
  flag: Flag, home: Home, work: Briefcase, school: BookOpen,
};

export const ICON_KEYS = Object.keys(ICONS);

export function IconFor({ name, className }) {
  const Cmp = ICONS[name] || Star;
  return <Cmp className={className} aria-hidden="true" />;
}
